import React from 'react';
import { theme } from 'antd';

interface SettingsCardProps {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  extra?: React.ReactNode;
  children: React.ReactNode;
  // Last card in a section skips the bottom margin so its own container
  // controls the final gap instead of double-spacing.
  noMarginBottom?: boolean;
}

/**
 * Soft rounded "creamy" card used to group a Settings section into visual
 * chunks (Legal details, Public profile, a toggle group...) -- the shared
 * building block behind the redesigned Settings page, matching the pill/
 * smooth language used across the rest of the app (HomeSearchBar, the
 * confirm-email page, PayoutIssueBanner).
 */
const SettingsCard: React.FC<SettingsCardProps> = ({ title, icon, extra, children, noMarginBottom }) => {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        background: token.colorBgContainer,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: 20,
        padding: 24,
        marginBottom: noMarginBottom ? 0 : 20,
        boxShadow: '0 1px 2px rgba(0,0,0,0.03), 0 8px 20px rgba(0,0,0,0.04)',
      }}
    >
      {(title || extra) && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
            marginBottom: 18,
          }}
        >
          {title && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, fontWeight: 600 }}>
              {icon}
              {title}
            </div>
          )}
          {extra}
        </div>
      )}
      {children}
    </div>
  );
};

export default SettingsCard;
